import React from 'react'
import styled from 'styled-components'
import Button from './Button'

interface Props {
  onClick?: () => void
  width?: string
  height?: string
  background?: string
}

const Border = styled.div<{ width?: string; height?: string }>`
  position: relative;
  width: ${({ width }) => width || 'auto'};
  height: ${({ height }) => height || '60px'};
  border-radius: 16px;
  background: linear-gradient(262.79deg, #fc7449 2.72%, #fd4869 46.62%, #fc2b51 95.76%);
  padding: 2px;
  :hover {
    filter: drop-shadow(0px 0px 48px rgba(253, 82, 98, 0.25));
  }
`

export const GradientOutlineButton: React.FC<Props> = ({ onClick, children, width, height, background }) => {
  return (
    <Border width={width} height={height}>
      <Button variant="outline" onClick={onClick} style={{ backgroundColor: background }}>
        {children}
      </Button>
    </Border>
  )
}
